"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.assistants = exports.assistantOptions = void 0;
var _capitalize2 = _interopRequireDefault(require("lodash/capitalize"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
var assistantContext = process.env.NODE_ENV === 'test' ? {
  keys: function keys() {
    return [];
  }
} : require.context('./assistants', true, /\S*index.js/);
var appAssistantContext = process.env.NODE_ENV === 'test' ? {
  keys: function keys() {
    return [];
  }
} : require.context('resources/assets/js', true, /^\.\/vendor\/flow\/assistants\/[^/]+\/index\.js$/);
var assistants = exports.assistants = {};
var assistantOptions = exports.assistantOptions = [{
  label: 'No assistant',
  value: ''
}].concat(_toConsumableArray(assistantContext.keys().map(function (key) {
  var value = key.replace(/^(\.\/)([^/]*)(.*)$/, '$2');
  var info = assistantContext(key)["default"];
  assistants[value] = info;
  return {
    label: info.name || (0, _capitalize2["default"])(value),
    value: value,
    thumbnail: info.thumbnail
  };
})), _toConsumableArray(appAssistantContext.keys().map(function (key) {
  var value = key.replace(/^.*\/([^/]+)\/index\.js$/, '$1');
  var info = appAssistantContext(key)["default"];
  var code = "app_".concat(value);
  assistants[code] = info;
  return {
    label: info.name || (0, _capitalize2["default"])(value),
    value: code,
    thumbnail: info.thumbnail
  };
})));